// Minnesotaänger Mini App — message list bottom marker.
// Trimmed from telegram-tt: the focus handler was removed; the bare element
// stays because `.messages-container` bottom anchoring relies on it being
// the last child.

import { memo } from '../../lib/teact/teact';

const MessageListBottomMarker = () => <div className="list-bottom-marker" />;

export default memo(MessageListBottomMarker);
